import gql from 'graphql-tag';


import { JobApprovalTickets } from './jobApprovalReview';
import { querySelector } from '../../../utils';


/*
* input: TicketReviewInput!
*   id: Int!
 */
export const ReviewTicket = gql`
  mutation ReviewTicket($input: TicketReviewInput!) {
    ticket_review(input: $input) {
      id
      state
    }
  }
`;


/*
* Convenience wrapper API for executing the ReviewTicket mutation
 */
const reviewTicketApi = async (client, jobId, ticketId) => {
  const variables = {
    input: {
      id: ticketId,
    },
  };

  const options = {
    mutation: ReviewTicket,
    variables,
    refetchQueries: [
      { query: JobApprovalTickets, variables: { jobId } },
    ],
  };

  const cachedQueryResults = client.readQuery({ query: JobApprovalTickets, variables: { jobId } });
  const oldCollection = querySelector(cachedQueryResults, '$.all_tickets.edges[*].node', []);
  const result = await client.mutate(options);

  return {
    oldCollection,
    result,
  };
};


export default reviewTicketApi;
